import { useContext } from "react";
import Spin from "../../../components/controls/spinner/Spin";
import { GanttChartContainer } from "./GanttContainer";
import { SharedTimelineContext } from "../SharedTimelineContext";
import "./style.css";
import KeyEventMarkers from "../components/KeyEventMarkers";

const ViewTypes = {
  Month: "month",
  Quarter: "quarter",
  Week: "week",
  Day: "day",
  Year: "year",
};

export const GanttChart = ({ 
  isHide, 
  viewType, 
  count, 
  isFullHeight, 
  entityType,
  keyEvents = []
}) => {
  const { isLoading, timelineData, displayYearRange, expandedProjects } = useContext(SharedTimelineContext);

  const storedHeight = localStorage.getItem("programGanttChartHeight");

  const height = isFullHeight
    ? "100vh - 240px"
    : storedHeight
    ? storedHeight
    : "100vh - 440px";

  if (isLoading) {
    return (
      <div
        className="h-full w-full flex items-center justify-center"
        style={{
          height: `calc(${height})`,
        }}
      >
        <Spin />
      </div>
    );
  }

  if (!timelineData || timelineData.length === 0) {
    return (
      <div
        className="w-full flex flex-col items-center justify-center"
        style={{
          height: `calc(${height})`,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="65"
          height="64"
          viewBox="0 0 65 64"
          fill="none"
          className="mb-2"
        >
          <path
            d="M6.9002 21.6008C6.9002 16.7407 10.8401 12.8008 15.7002 12.8008H49.3002C54.1603 12.8008 58.1002 16.7407 58.1002 21.6008V42.4008C58.1002 47.2609 54.1603 51.2008 49.3002 51.2008H32.8884L27.8968 46.2092C28.7964 44.3293 29.3002 42.2239 29.3002 40.0008C29.3002 32.0479 22.8531 25.6008 14.9002 25.6008C11.94 25.6008 9.18835 26.494 6.9002 28.0257V21.6008ZM14.9002 51.2008C17.416 51.2008 19.7381 50.3713 21.6079 48.9708L29.7688 57.132C30.3936 57.7569 31.4067 57.7569 32.0315 57.1321C32.6564 56.5072 32.6564 55.4942 32.0316 54.8693L23.8706 46.708C25.2708 44.8384 26.1002 42.5164 26.1002 40.0008C26.1002 33.8152 21.0858 28.8008 14.9002 28.8008C8.71461 28.8008 3.7002 33.8152 3.7002 40.0008C3.7002 46.1864 8.71461 51.2008 14.9002 51.2008ZM14.9002 48.0008C10.4819 48.0008 6.9002 44.4191 6.9002 40.0008C6.9002 35.5825 10.4819 32.0008 14.9002 32.0008C19.3185 32.0008 22.9002 35.5825 22.9002 40.0008C22.9002 44.4191 19.3185 48.0008 14.9002 48.0008Z"
            fill="#342C82"
          />
        </svg>
        <h5 className="text-lg font-semibold text-gray-800 mb-1">
          No Timeline available
        </h5>
        <p className="text-gray-600 text-center max-w-md">
          There are no timeline available for selected program.
        </p>
      </div>
    );
  }

  return (
    <GanttChartContainer
      viewType={ViewTypes[viewType]}
      isHide={isHide}
      count={count}
      isFullHeight={isFullHeight}
      entityType={entityType}
      keyEvents={keyEvents}
    >
      <KeyEventMarkers
        keyEvents={keyEvents}
        timelineData={timelineData}
        viewType={viewType}
        displayYearRange={displayYearRange}
        expandedProjects={expandedProjects}
      />
    </GanttChartContainer>
  );
};
